$('.wa-reviews-owl-carousel').owlCarousel({
    margin: 20,
    loop: false,
    nav: false,
    dots: true,
    responsive: {
        1300: {
            items: 2,
            dots: true
        },
        800: {
            items: 2,
            dots: true
        },
        600: {
            items: 2,
        },
        400: {
            items: 1,
        },
        0: {
            items: 1,
        }
    },
});

$('.wa-payent-owl-carousel').owlCarousel({
    margin: 20,
    loop: false,
    nav: false,
    dots: false,
    responsive: {
        1300: {
            items: 5,
        },
        800: {
            items: 5,
        },
        600: {
            items: 3,
        },
        400: {
            items: 2,
        },
        0: {
            items: 2,
        }
    },
});

/*
    function jackMousein(x){
        let nodd = x.parentElement;
        nodd.setAttribute('megaopen', true)
    }
    function jackMouseout(x){
        let  nodd = x.parentElement;
        nodd.removeAttribute('megaopen')
    }
    let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
    items.forEach(item => {
        
        item.addEventListener("mouseover", () => {
            item.setAttribute("open", true);
            item.querySelector("ul").addEventListener("mouseleave", () => {
                setTimeout(function(){
                    if(item.hasAttribute('megaopen')){
                        item.setAttribute("open", true);
                    }
                    else{
                        
                        item.removeAttribute("open");
                    }
                }, 500);
            });
            item.addEventListener("mouseleave", () => {
                
                setTimeout(function(){
                    if(item.hasAttribute('megaopen')){
                        item.setAttribute("open", true); 
                    }
                    else{
                        
                        item.removeAttribute("open");
                    }
                }, 100);
            });
        }); 
    });

*/

document.addEventListener("DOMContentLoaded", function() {
    const subCategoryDivs = document.querySelectorAll('.wa-cat-div');
    let openedSubCategory = null;

    subCategoryDivs.forEach(div => {
        const subCategoryContainer = div.querySelector('.wa-sub-cats-name');
        const arrowIcon = div.querySelector('.waiconcaret');

        // Open the default subcategory if current is true
        if (div.getAttribute('data-current') === 'true') {
            subCategoryContainer.style.display = 'block';
            arrowIcon.classList.add('rotate');
            openedSubCategory = div;
        }

        // Check subcategory2.current for initial display
        const subcategory2Links = div.querySelectorAll('.wa-cat-link2');
        subcategory2Links.forEach(link => {
            if (link.getAttribute('data-current') === 'true') {
                subCategoryContainer.style.display = 'block';
                arrowIcon.classList.add('rotate');
            }
        });
    });

    const toggleElements = document.querySelectorAll('.wa-cat-name-div, .waiconcaret');

    toggleElements.forEach(element => {
        element.addEventListener('click', function(event) {
            event.stopPropagation();

            const parentDiv = element.closest('.wa-cat-div');
            const subCategoryContainer = parentDiv.querySelector('.wa-sub-cats-name');
            const arrowIcon = parentDiv.querySelector('.waiconcaret');

            // If clicked element is already open, close it
            if (subCategoryContainer.style.display === 'block') {
                subCategoryContainer.style.display = 'none';
                arrowIcon.classList.remove('rotate');
                openedSubCategory = null;
            } else {
                // Close previously opened subcategory
                if (openedSubCategory && openedSubCategory !== parentDiv) {
                    const prevSubCategoryContainer = openedSubCategory.querySelector('.wa-sub-cats-name');
                    const prevArrowIcon = openedSubCategory.querySelector('.waiconcaret');
                    prevSubCategoryContainer.style.display = 'none';
                    prevArrowIcon.classList.remove('rotate');
                }

                // Open the clicked subcategory
                subCategoryContainer.style.display = 'block';
                arrowIcon.classList.add('rotate');
                openedSubCategory = parentDiv;
            }
        });
    });
});


document.addEventListener("DOMContentLoaded", function() {
    const subCategoryDivs = document.querySelectorAll('.wa-cat-div');
    
    subCategoryDivs.forEach(div => {
        const subCategoryContainer = div.querySelector('.wa-sub-cats-name');
        const subcategory2Links = div.querySelectorAll('.wa-cat-link2');
        const arrowIcon = div.querySelector('.waiconcaret');
        const currentUrl = window.location.href;

        subcategory2Links.forEach(link => {
            if (link.href === currentUrl) {
                // Open the parent category and make the current link bold
                subCategoryContainer.style.display = 'block';
                arrowIcon.classList.add('rotate');
                link.style.fontWeight = 'bold'; // BOLD
              link.style.color = 'green'; 
            }
        });
    });
});




